module.exports = __webpack_public_path__ + "static/img/5.6347aeb6.png";